module.exports = __webpack_public_path__ + "static/media/buy_cancel_10.2cb0eee8.png";